import { createLocale } from "./createLocale";

export const et = createLocale({
  header: {
    title: "Mine üleilmseks. 2 $ ühe lühivideo eest. Iga keel!",
    subtitle: "🔥Maksa ainult tulemuse eest – alates $0.089 kuni $0.009 sekundis🔥",
  },
  steps: {
    uploadVideo: "Laadi video üles",
    selectLanguages: "Vali keeled",
    conversionResult: "Teisendus ja tulemus",
  },
  upload: {
    dragAndDrop: "Lohistage videofail siia",
    orClickToSelect: "või klõpsake valimiseks",
    supportedFormats: "Toetatud vormingud: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maksimaalne faili suurus: 200 MB",
    maxDuration: "• Maksimaalne kestus: 30 sek",
    chooseFile: "Vali fail",
    selectedFile: "Valitud fail:",
    size: "Suurus:",
    fileTypeError: "Palun valige videofail",
    fileSizeError: "Faili suurus ({size} MB) ületab maksimaalse piiri 200 MB",
    durationError: "Video kestus ({duration} sek) ületab maksimaalse piiri 30 sek",
    fileReadError: "Videofaili ei saa lugeda. Proovige teist faili.",
  },
  languages: {
    sourceAudioLanguage: "Lähteheli keel",
    targetAudioLanguage: "Sihtheli keel",
    selectLanguage: "Vali keel...",
  },
  conversion: {
    replaceAudio: "Klooni mu hääl",
    uploadVideoAndSelectLanguages: "Laadi video üles ja vali jätkamiseks keeled",
  },
  nav: {
    blog: "Blogi",
  },
  footer: {
    privacyPolicy: "Privaatsuspoliitika",
    termsOfUse: "Kasutustingimused",
  },
  languageOptions: {
    et: "Eesti",
  },
});
